import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, IsActiveMatchOptions } from '@angular/router';
import { filter } from 'rxjs/operators';
import { coreConfig } from 'app/app-config';
import { ParametreService } from './parametre.service';
import {HeaderService} from "../../../services/header/header.service";

@Component({
  selector: 'app-main-parametre',
  templateUrl: './main-parametre.component.html',
  styleUrls: ['./main-parametre.component.scss'],
  host: { class: 'email-application' }
})
export class MainParametreComponent implements OnInit {
  @ViewChild('contentWrapper') contentWrapper: ElementRef;
  animation = 'fadeIn';
  numArray: number[] = [];
  page: string = 'p-e';
  private currentRoute: string;

  /**
   * Garde le surlignage du sous-menu (ex. Produits) lors des changements d’onglet
   * ?tab=import, ?tab=champs, etc. — sans ça, exact: true comparait aussi les query params.
   */
  readonly donneesSubLinkActiveOptions: IsActiveMatchOptions = {
    paths: 'exact',
    queryParams: 'ignored',
    fragment: 'ignored',
    matrixParams: 'ignored'
  };

  /**
   * Sur /main/parametre/donnees/** : sidebar limitée au sous-menu données uniquement
   * (les autres entrées passent par l’icône engrenage de la barre).
   */
  showParametreDonneesNav = false;

  constructor(private headerService: HeaderService, private router: Router, private activatedRoute: ActivatedRoute, private parametreService: ParametreService) {}

  private setParametreDonneesNavVisibility(url: string): void {
    this.showParametreDonneesNav = /\/main\/parametre\/donnees(\/|$)/.test(url || '');
  }

  /** Met à jour le titre du header selon l’URL (ex. navigation depuis le menu engrenage). */
  private syncPageFromUrl(url: string): void {
    const u = url || '';
    if (/\/main\/parametre\/donnees(\/|$)/.test(u)) {
      this.changeActive('p-db');
      return;
    }
    if (u.includes('/main/parametre/taxe-tva')) this.changeActive('t-tva');
    else if (u.includes('/main/parametre/entreprise')) this.changeActive('p-e');
    else if (u.includes('/main/parametre/document')) this.changeActive('p-d');
    else if (u.includes('/main/parametre/compte-bancaire')) this.changeActive('c-b');
    else if (u.includes('/main/parametre/liste-prix')) this.changeActive('l-p');
    else if (u.includes('/main/parametre/comptable-parametre')) this.changeActive('c-p');
    else if (u.includes('/main/parametre/user-and-role')) this.changeActive('u-r');
    else if (u.includes('/main/parametre/integration')) this.changeActive('i-p');
    else if (u.includes('/main/parametre/marque-categorie')) this.changeActive('m-c');
    else if (u.includes('/main/parametre/projets')) this.changeActive('p-j');
  }

  ngOnInit(): void {
    this.setParametreDonneesNavVisibility(this.router.url);
    this.syncPageFromUrl(this.router.url);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.urlAfterRedirects;
        this.setParametreDonneesNavVisibility(event.urlAfterRedirects);
        this.syncPageFromUrl(event.urlAfterRedirects);
     //   this.updatePageFromRoute();
        const el = this.contentWrapper?.nativeElement;
        if (el) {
          el.classList.remove('animate__fadeIn');
          void el.offsetWidth;
          el.classList.add('animate__fadeIn');
        }
      });

      this.headerService.setConfig({
          title: this.getTitle(this.page),
          buttons: [

          ]
      });
  }

  updatePageFromRoute(): void {
    const url = this.currentRoute || '';

    if (url.includes('/main/parametre/taxe-tva')) {
      this.page = 't-tva';
    } else if (url.includes('/main/parametre/entreprise')) {
      this.page = 'p-e';
    } else if (url.includes('/main/parametre/document')) {
      this.page = 'p-d';
    } else if (url.includes('/main/parametre/compte-bancaire')) {
      this.page = 'c-b';
    } else if (url.includes('/main/parametre/liste-prix')) {
      this.page = 'l-p';
    } else if (url.includes('/main/parametre/comptable-parametre')) {
      this.page = 'c-p';
    } else if (url.includes('/main/parametre/user-and-role')) {
      this.page = 'u-r';
    } else if (url.includes('/main/parametre/integration')) {
      this.page = 'i-p';
    } else if (url.includes('/main/parametre/marque-categorie')) {
      this.page = 'm-c';
    } else if (url.includes('/main/parametre/projets')) {
      this.page = 'p-j';
    } else if (url.includes('/main/parametre/donnees')) {
      this.page = 'p-db';
    } else if (url.includes('/produits/categories')) {
      this.page = 'm-c';
    } else {
      this.page = this.page || 'p-e';
    }
  }

  getTitle(page: string): string {
    const titles = {
      'p-e': 'Profil de l\'entreprise',
      'p-d': 'Paramètres des documents',
      'c-b': 'Compte bancaire',
      't-tva': 'Taxes et TVA',
      'l-p': 'Listes de prix',
      'c-p': 'Comptable',
      'u-r': 'Utilisateurs et rôles',
      'i-p': 'Intégration',
      'p-j': 'Projets',
      'm-c': 'Marques, Catégories et Unités',
      'p-db': 'Paramètres des données'
    };
    return titles[page] || 'Paramètres';
  }

  showAddButton(page: string): boolean {
    return ['t-tva', 'l-p', 'u-r', 'i-p', 'm-c'].includes(page);
  }
  
handleAddAction(page: string): void {
  console.log('handleAddAction called for page:', page); // Debug log
  switch (page) {
    case 't-tva':
      console.log('Triggering modal for taxe-tva');
      this.parametreService.triggerModal('taxe-tva', 'add', 'taxe'); 
      break;
    case 'l-p':
      console.log('Triggering modal for liste-prix');
      this.parametreService.triggerModal('liste-prix', 'add');
      break;
    case 'u-r':
      this.router.navigate(['/main/parametre/user-and-role/ajouter']);
      break;
    case 'i-p':
      console.log('Triggering modal for integration');
      this.parametreService.triggerModal('integration', 'add');
      break;
    case 'm-c':
      console.log('Triggering modal for marque-categorie');
      this.parametreService.triggerModal('marque-categorie', 'add');
      break;
  }
}

  changeActive(p: string) {
      this.page = p;
      this.headerService.setConfig({
          title: this.getTitle(this.page),
          buttons: [
              // Update buttons if needed
          ]
      });
  }

  prepareRoute(outlet: any) {
    return outlet.activatedRouteData['animation'];
  }
}